/* eslint-disable import/prefer-default-export */
import { ENV } from '@/services/utils';

const urlCollect = {
  // 开发环境
  dev: {
    url: '//test-deploy.api.xiaoyuanhao.com/nbugs-bridge-qa',
  },
  // 测试环境
  test: {
    url: '//test-deploy.api.xiaoyuanhao.com/nbugs-bridge-qa',
  },
  // 生产环境
  production: {
    url: '//bridge.api.xiaoyuanhao.com',
  },
};

export const url = urlCollect[ENV];
